import { useCookies } from "react-cookie";
import { useSearchParams } from "react-router-dom";
import { useAuthVkMutation } from "../../api/main/user";
import { useEffect, useState } from "react";


function ExternalAuthVk() {
  //https://user-office.ru/auth/vk?code=vk2.a.3Nym4gichmDls_DGQiFxBlksN8hWpZigWg2Vzaus_uDqbzXn-lxocPIVGcZcbUvXa46Fajd4Rf9L9xU18LeQqjLJvfDw-1YTT7rT17kkX1AcD0kPshekR9S-tsmJq4vlWqJRpz2U6VQWRHb1jGMPGNFwj2dq7fGjSrL5wdzkz_5VGt5gWiePsmkvDDrRJ_HwaLVXYoXFUfsXdqUZ5FSNcg&expires_in=600&device_id=Nl1tTVH_TMpd4fB4uSRoTsOzJKRkiNz2LzgLr2uVQ1QsJlpV04JGOv2yGwzvQj8UjPmaALMtPYcKZMKxo4HlPw&state=&ext_id=Dh-vifjwC_iVsLARJC0UZoKfURP95mXglzuTkHMNZyhyqDR5mRi4CDr2z0or00KKPMJNx_7cBXnFGLU9NQapgBbvXrEEnByIEGggyTx1v3JZPPwabGy_vvPloOa-f0zBOlRg4bVb3axMHU9_qxQ8jzffTApAfDDZ1vv9F6bkUNc&type=code_v2

  const [log, setLog] = useState(null);
  const [loading, setLoading] = useState(false);
  const [authSuccess, setAuthSuccess] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const code = searchParams.get("code");
  const device_id = searchParams.get("device_id");
  const state = searchParams.get("state");

  const [authVkApi] = useAuthVkMutation();

  const [cookiesPromo, setCookiePromo, removeCookiePromo] = useCookies(['biz_promo']);
  const [cookies, setCookie, removeCookie] = useCookies(['biz_outh_srv']);

  useEffect(() => {
    setLoading(true);
    authVkApi({ device_id: device_id, code: code, state: state, promo: cookiesPromo.biz_promo })
      .unwrap()
      .then((res) => {
        if (res.Status !== 1) {
          setLog(res.Error);
          setLoading(false);
        }
        else {
          setAuthSuccess(true);
          const srv = cookies.biz_outh_srv;
          if (srv === 2) {
            return window.location.replace(process.env.REACT_APP_DOMAIN_TRACKER + '/lk');
          }
        }
      })
      .catch((err) => {
        setLog('Неизвестная ошибка!');
        setLoading(false);
      });
  }, []);

  return (
    <>
      <div className="row mt-5 mb-5">
        <div className="col-md-12 text-center">
          <h1>Авторизация VK ID</h1>
        </div>
      </div>

      {loading === true && (
        <div className="row mt-5 mb-5">
          <div className="col-md-12 text-center log_form">
            <span className="loader_01"></span>
          </div>
        </div>
      )}
      {log !== null && (
        <div className="row mt-5 mb-5">
          <div className="col-md-12 text-center log_form">
            {log}
          </div>
        </div>
      )}
      {authSuccess === true && (
        <>
          <div className="row mt-5 mb-5">
            <div className="col-lg-4">

            </div>
            <div className="col-lg-4 text-center text-success">
              Успешная авторизация. Для продолжения выберите сервис:
            </div>
            <div className="col-lg-4">

            </div>
          </div>
          <div className="row mt-5 mb-5">
            <div className="col-lg-4">

            </div>
            <div className="col-lg-4">
              <h1 className="text-center mt-5">Вы вошли</h1>
              <div className="text-center mt-2">Выберите сервис для входа:</div>
              <div className="srv_block mt-5">
                <a href={process.env.REACT_APP_DOMAIN_TRACKER + "/lk"}>
                  <div className="srv_card">
                    <div className="header">Трекер задач</div>
                  </div>
                </a>
              </div>
            </div>
            <div className="col-lg-4">

            </div>
          </div>
        </>
      )}
    </>
  );
}

export default ExternalAuthVk;
